<template>
  <gh-table-page ref="table" :args-query="args" module="mes.business.sys.source.service" cls="SourceService"
    @EditCode="editCode" @reCompile="reCompile">
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
    <template #area_detail="{current}">

    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Source from "./source.ts";
  export default Source;
</script>